/**
 * @param {登录成功后回调通知} callback
 */
function LoginDialog() {
  const that = this;
  // 显示登录弹窗
  $('.header .header-login div .left #btn-id-login').on('click', function() {
    const strToken = $('.login').attr('data');
    const strText = $('.header .header-login div .left #btn-id-login').text();
    if (strToken || strText === '退出登录') {
      that.logoutSystem();
    } else {
      that.show();
    }
  });
  // 隐藏登录弹窗
  $('.login .alert-dialog-bk .login-panel div.row-btn #btn-id-cancel').on('click', function() {
    that._hidden();
  });
  // 登录
  $('.login .alert-dialog-bk .login-panel div.row-btn #btn-id-ok').on('click', function() {
    that._loginSystem();
  });
  // 获取短信验证码
  $('div #btn-obtain-sms').on('click', function() {
    that._sendSMS();
  });
};
LoginDialog.prototype = {
  show: function(callback) {
    $('.login').css('display', 'block');
    $('.login-panel .row .col-80 input').each(function() {
      $(this).val('');
    });
    this.callback = callback;
  },
  _hidden: function() {
    $('.login').css('display', 'none');
  },
  _loginSystem: function() {
    const displayTipView = require('./common').displayElementView;
    var strMobile = $('input[name="mobile"]').val();
    var strSMS = $('input[name="sms"]').val();
    const tipElement = $('div .tip');
    if (strMobile == null || strMobile.length === 0) {
      displayTipView(tipElement, '请输入手机号码');
    } else if (strMobile.length !== 11) {
      displayTipView(tipElement, '请输入有效的手机号码');
    } else if (strSMS == null || strSMS.length === 0) {
      displayTipView(tipElement, '请输入短信验证码');
    } else {
      const that = this;
      $.ajax({
        type: 'GET',
        url: '/login',
        headers: {
          'Content-Type': 'application/json'
        },
        data: {'mobile': strMobile, 'sms': strSMS},
        success: function(response) {
          if (response && (response.errno == 0) && response.data && response.data.result) {
            that._hidden();
            if (response.token) {
              $('.login').attr('data', response.token);
            }
            const elementLogin = $('.header-block .left #btn-id-login');
            if (elementLogin && elementLogin.length > 0) {
              elementLogin.html('退出登录');
            } else if (location.href.indexOf('/product/detail/') !== -1) {
              location.reload();
            }
            if (that.callback) {
              that.callback();
            }
          } else {
            let msg = '登录失败！';
            if (response && response.data && response.data.msg) {
              msg = response.data.msg;
            }
            displayTipView(tipElement, msg);
          }
        }
      });
    }
  },
  logoutSystem: function() {
    $.ajax({
      type: 'GET',
      url: '/login/logout',
      success: function(response) {
        if (response && (response.errno === 0) && response.data && !response.data.msg) {
          $('.header-block .left #btn-id-login').html('请登录');
          $('.login').attr('data', '');
        } else {
        }
      }
    });
  },
  _sendSMS: function() {
    const btnSMS = $('.login .alert-dialog-bk .login-panel div .col-80 #btn-obtain-sms');// 获取短信验证码按钮
    if (btnSMS.attr('class') === 'disable') {
      return;
    }
    const displayTipView = require('./common').displayElementView;
    var strMobile = $('input[name="mobile"]').val();
    const tipElement = $('div .tip');
    if (strMobile == null || strMobile.length === 0) {
      displayTipView(tipElement, '请输入手机号码');
    } else if (strMobile.length !== 11) {
      displayTipView(tipElement, '请输入有效的手机号码');
    } else {
      $.ajax({
        type: 'GET',
        url: '/login/sendSMS',
        data: {'mobile': strMobile},
        success: function(response) {
          if (response && (response.errno === 0)) {
            $('input[name="sms"]').html('');
            displayTipView(tipElement, '短信验证码发送成功！', '#7acc88');
            var nCount = 60;
            btnSMS.html(nCount);
            btnSMS.attr('class', 'disable');
            const tiemr = setInterval(function() {
              btnSMS.html(nCount);
              nCount--;
              if (nCount <= 0) {
                btnSMS.html('点击获取验证码');
                btnSMS.removeClass('disable');
                clearInterval(tiemr);
              }
            }, 1000);
          } else {
            displayTipView(tipElement, '短信验证码发送失败！');
            tipElement.html('短信验证码发送失败！');
          }
        }
      });
    }
  }
};
module.exports.LoginDialog = LoginDialog;
